import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-button',
	templateUrl:'./WaButtonPage.html',
	styles: [],
	styleUrls:['./WaButtonPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaButtonPage
{
	mdContent_288 = `\`\`\`java
import com.jwebmp.webawesome.components.button.WaButton;
\`\`\``;
	mdContent_289 = `\`\`\`java
new WaButton<>()
\`\`\``;
	mdContent_290 = `\`\`\`java
new WaButton<>(String text)
\`\`\``;
	mdContent_291 = `\`\`\`java
new WaButton<>(String text, Variant variant)
\`\`\``;
	mdContent_292 = `\`\`\`java
var btn = new WaButton<>("Click Me", Variant.Brand);
\`\`\``;
	mdContent_293 = `\`\`\`java
var btn = new WaButton<>("Delete", Variant.Danger);
btn.setAppearance(Appearance.Outlined);
\`\`\``;
	mdContent_294 = `\`\`\`java
var btn = new WaButton<>("Settings", Variant.Neutral);
btn.setPrefix(new WaIcon<>("gear"));
\`\`\``;
	mdContent_295 = `\`\`\`java
var btn = new WaButton<>("Saving...", Variant.Success);
btn.setPill(true);
btn.setLoading(true);
\`\`\``;
	mdContent_296 = `\`\`\`java
var btn = new WaButton<>("Visit Site", Variant.Brand);
btn.setAsLink("https://example.com", "_blank", null);
\`\`\``;
}
